export default __webpack_public_path__ + "static/media/NewAddIcon.f3a2a482.svg";